import { zodResolver } from "@hookform/resolvers/zod";
import {
	Button,
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
	Input,
} from "@monbits/ui";
import type * as React from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";

interface Props {
	onFinish: (values: string) => Promise<void>;
	isFormSubmitting: boolean;
}

const formSchema = z.object({
	name: z.string().min(1, "Give your key a name."),
});

type FormValues = z.infer<typeof formSchema>;

const TokenCreateForm: React.FC<Props> = (props: Props) => {
	const form = useForm<FormValues>({
		resolver: zodResolver(formSchema),
		defaultValues: {
			name: "",
		},
	});

	const onSubmit = async (values: FormValues) => {
		await props.onFinish(values.name);
		form.reset();
	};

	return (
		<Form {...form}>
			<form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
				<FormField
					control={form.control}
					name="name"
					render={({ field }) => (
						<FormItem>
							<FormLabel>Key name</FormLabel>
							<FormControl>
								<Input placeholder="Production server" {...field} />
							</FormControl>
							<FormMessage />
						</FormItem>
					)}
				/>
				<Button type="submit" className="sr-only">
					Submit
				</Button>
			</form>
		</Form>
	);
};

export default TokenCreateForm;
